import { Avatar, Box, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { useSession } from '@tgtg/core/session';
import { vars } from '@tgtg/kit';
import { useState, type MouseEvent } from 'react';

import UserMenuPopover from '../UserMenuPopover';

const UserMenu = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isPopoverOpen = Boolean(anchorEl);
  const {
    session: { userEmail },
  } = useSession();

  const handleProfileClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  return (
    <Box>
      <ListItem
        disablePadding
        sx={{
          borderRadius: vars.radius.medium,
          overflow: 'hidden',
        }}
      >
        <ListItemButton
          onClick={handleProfileClick}
          sx={{
            '&:hover': {
              backgroundColor: vars.color.surface.interactive.opacityOverlayHover,
            },
            ...(isPopoverOpen && {
              backgroundColor: vars.color.surface.interactive.opacityOverlayPressed,
            }),
          }}
        >
          <ListItemAvatar
            sx={{ minWidth: `calc(${vars.size.xlarge} + ${vars.spacing.neutral.medium})` }}
          >
            <Avatar
              sx={{
                width: vars.size.xlarge,
                height: vars.size.xlarge,
                bgcolor: vars.color.surface.interactive.primary,
              }}
            >
              S
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={userEmail}
            primaryTypographyProps={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontWeight: 500,
              fontFamily: vars.typography.labels.medium.fontFamily,
              fontSize: vars.typography.labels.medium.fontSize,
            }}
          />
        </ListItemButton>
      </ListItem>
      <UserMenuPopover
        anchorEl={anchorEl}
        isPopoverOpen={isPopoverOpen}
        onPopoverClose={handlePopoverClose}
      />
    </Box>
  );
};

export default UserMenu;
